// extracted by mini-css-extract-plugin
export default {"root":"LiveAudioVisualizer_root__PTDz3","styleReference":"LiveAudioVisualizer_styleReference__-uLRc","header":"LiveAudioVisualizer_header__cxYNQ"};